module.exports = __webpack_public_path__ + "fonts/Inter-Regular.41cd706.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Inter/Inter-Regular.woff
// module id = 182
// module chunks = 245 246